import history from '../../history';
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import {
    getContentPageDetailsQuery as query,
    deleteContentPageMutation,
    updateContentStatusMutation
} from '../../lib/graphql';

const deleteContentPageDetails = (id) => {
    try {
        return async (dispatch, getState, { client }) => {
            let requestContent = {};

            const { data } = await client.mutate({
                mutation: deleteContentPageMutation,
                variables: { id },
                refetchQueries: [{ query }]
            });

            if (data?.deleteContentPage?.status === 200) {
                showToaster({ messageId: 'changesUpdated', toasterType: 'success' });
                history.push('/siteadmin/contentpage/manage')
            } else if (data?.deleteContentPage?.status !== 200) {
                requestContent = {
                    content: data?.deleteContentPage?.errorMessage
                };
                showToaster({ messageId: 'errorMessage', requestContent, toasterType: 'error' });
            } else {
                showToaster({ messageId: 'errorMessage', toasterType: 'error' });
            }
        }
    }
    catch (error) {
        showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });
    }
}

const updateContentPageStatus = (id, isEnable) => {
    try {
        return async (dispatch, getState, { client }) => {
            let requestContent = {};

            const { data } = await client.mutate({
                mutation: updateContentStatusMutation,
                variables: { id, isEnable },
                refetchQueries: [{ query }]
            });

            if (data?.updateContentPageStatus?.status === 200) {
                showToaster({ messageId: 'changesUpdated', toasterType: 'success' });
                history.push('/siteadmin/contentpage/manage')
            } else if (data?.updateContentPageStatus?.status !== 200) {
                requestContent = {
                    content: data?.updateContentPageStatus?.errorMessage
                };
                showToaster({ messageId: 'errorMessage', requestContent, toasterType: 'error' });
            } else {
                showToaster({ messageId: 'errorMessage', toasterType: 'error' });
            }
        }
    } catch (error) {
        showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });
    }
}

export {
    deleteContentPageDetails,
    updateContentPageStatus
};